
export function clientContactToForm(contact) {
    let cleanedContact = Object.assign({}, contact);

    if (cleanedContact.client !== undefined && cleanedContact.client.id !== undefined) {
        cleanedContact.client = cleanedContact.client.id;
    }

    return cleanedContact;
}


// WEBPACK FOOTER //
// ./src/utils/clientContact.js